export const getLocaleSeparator = () => 0.1.toLocaleString().replace(/\d/g, '');